<mat-sidenav-container class="w-full h-full">
  @let isHandset = isHandset$ | async;
  <mat-sidenav
    #drawer
    class="!bg-[#ffffff] !w-[250px]"
    fixedInViewport
    [attr.role]="isHandset ? 'dialog' : 'navigation'"
    [mode]="isHandset ? 'over' : 'side'"
    [opened]="isHandset === false"
  >
    <mat-toolbar class="bg-inherit">
      <img alt="logo" class="mx-auto w-[80%] h-[80%]" [src]="environment.logo.primary"/>
    </mat-toolbar>
    <mat-nav-list>
      @for (menuItem of mainMenuConfig.items | filterMenuItemsByRole; track $index) {
        <a
          #routerLinkActiveDirective="routerLinkActive"
          class="animated"
          mat-list-item
          routerLinkActive="active"
          [class.!bg-green-100]="routerLinkActiveDirective.isActive"
          [class.item-disabled]="routerLinkActiveDirective.isActive"
          [name]="`main-menu-item-${menuItem.name}`"
          [routerLink]="menuItem.routeLink"
          [routerLinkActiveOptions]="{ exact: false }"
          (click)="isHandset ? drawer.close() : 0"
          (isActiveChange)="onIsActiveChangeMainMenuItem(menuItem, $event)"
        >
          <mat-icon matListItemIcon [customMatSvgIcon]="menuItem.icon" />
          {{ menuItem.label | resolveTranslateAbleText }}
        </a>
      }
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content class="bg-[#e2e2f7]">
    <mat-toolbar
      class="app-toolbar fixed top-0 z-1 w-full z-[99]"
      color="primary"
      [class.!w-[calc(100%-250px)]]="drawer.opened && isHandset === false"
    >
      @if (isHandset) {
        <button aria-label="Toggle sidenav" mat-icon-button type="button" (click)="drawer.toggle()">
          <mat-icon aria-label="Side nav toggle icon" customMatSvgIcon="pct-mdi-menu" />
        </button>
      }
      <div class="w-full grid grid-flow-col auto-cols-max justify-between items-center">
        <span class="text-base md:text-lg lg:text-2xl">{{ title() }}</span>
        <app-layout-menu
          [items]="topRightMenuConfig"
          [mainLabelText]="me()?.name ?? ''"
        />
      </div>
    </mat-toolbar>
    <div
      class="app-content pt-[var(--mat-toolbar-standard-height,56px)] md:pt-[var(--mat-toolbar-standard-height,64px)] m-[24px]"
    >
      <router-outlet />
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
